import * as React from 'react';

import Dropdown from 'af-components/Controls/Dropdown';

import styles from './styles.module.scss';

export interface MainFilterOption {
	id: number;
	label: string;
}

interface Props {
	options: MainFilterOption[];
	onChange: (id: number) => void;
	defaultValue?: number;
}

const MainFilter: React.FC<Props> = ({ options, onChange, defaultValue }) => {

	const renderOption = React.useCallback((option: MainFilterOption) => {
		return (
			<>
				Filter by {option.label}
			</>
		);
	}, []);

	const renderSelected = React.useCallback((option: MainFilterOption) => {
		return (
			<div className={styles['main-filter__selected']}>
				<span className="icon-filter" />
				Filter by {option.label}
			</div>
		);
	}, []);

	const onValueChange = React.useCallback((option: MainFilterOption) => {
		onChange(option.id);
	}, [onChange]);

	const defaultOption = React.useMemo(() => {
		const _option = options.find((option) => option.id === defaultValue);
		return _option ?? options[0];
	}, [defaultValue, options]);

	return <div className={styles['main-filter']}>
		<Dropdown<MainFilterOption>
			defaultValue={defaultOption}
			dropdownId="accqa__table-main-filter"
			onValueChange={onValueChange}
			options={options}
			renderMenuItem={renderOption}
			renderSelected={renderSelected}
			valueKey="id"
		/>
	</div>;
};

export default React.memo(MainFilter);
